<template>
  <div>
    <button
      type="button"
      class="btn btn-lg btn-brand btn-elevate btn-circle btn-icon"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="flaticon2-plus"></i>
    </button>

    <div class="dropdown-menu" style="min-width:250px">
      <a
        class="dropdown-item"
        href="#"
        v-for="(service, index) in services"
        :key="index"
        @click.prevent="setSelectedService(service)"
      >
        <span class="kt-menu__link-icon">
          <i v-if="service.menu_icon" :class="service.menu_icon"></i>
          <i v-else class="flaticon2-dashboard"></i>
        </span>
        <span class="kt-menu__link-text">{{ service.title }}</span>
      </a>
    </div>
  </div>
</template>
<script>
import ServicesMenuMixin from "@/mixins/servicesMenu.js";

export default {
  name: "ServicesDropdown",
  mixins: [ServicesMenuMixin],
};
</script>

<style scoped>
.kt-menu__link-icon {
  flex: 0 0 35px;
}
</style>
